import { render } from "./CancellationSection.vue?vue&type=template&id=34ff574e&scoped=true&ts=true"
import script from "./CancellationSection.vue?vue&type=script&lang=ts"
export * from "./CancellationSection.vue?vue&type=script&lang=ts"

import "./CancellationSection.vue?vue&type=style&index=0&id=34ff574e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ff574e"]])

export default __exports__